import DuckEntity from './DuckEntity'

const entity = new DuckEntity('contacts');
const reducer = entity.reducer;
export {reducer as default, entity};
